import LogoGarden from './LogoGarden'

export default LogoGarden
